import { action, computed, makeObservable, observable } from 'mobx'
import moment from 'moment'
import {
  isAdmin,
  isDealer,
  isOperator,
  isSuperOperator,
} from '../../../services/AccountService'
import {
  acceptServiceOrder,
  addServiceOrderComment,
  assignServiceOrderOnDealer,
  backToServiceCenterAfterRevision,
  beginWorkWithOrder,
  changeServiceEquipmentId,
  createServiceOrder,
  createServiceSolvedOrder,
  getInstalledOrders,
  getReworkServiceOrders,
  getServiceOrderComments,
  getServiceOrders,
  getServicePhotos,
  getServiceReasons,
  getUploadServicePhotoSettings,
  improvementRequired,
  maintenanceOrdersRelease,
  maintenanceOrdersTake,
  markServiceOrderAsDuplicate,
  noWrrantyDiagnostic,
  sendToDiagnostic,
  serviceImpossible,
  setToRejectedByCustomer,
  solvewithoutvisit,
  toGuaranteeRepairOperator,
  updateServiceOrderPut,
  wrrantyDiagnostic,
} from '../../../services/ApiService'
import {
  notifyError,
  notifySuccess,
} from '../../../services/ToastifyService/ToastifyService'
import webSocketService from '../../../services/WebSocketService'
import { gState } from '../../../utils/controllers/GlobalStateController'
import {
  closeModalFn,
  openModalFn,
} from '../../../utils/controllers/ModalController'
import PagedCollectionStore from '../../../utils/stores/PagedCollectionStore'
import { getComp } from '../../../utils/utils/DI'
import IntermediateDrawerFormStore from './IntermediateDrawerFormStore'
import ServiceAddRequestFormStore from './ServiceAddRequestFormStore'
import ServiceFilterStore from './ServiceFilterStore'
import ServiceInformationAccordionFormStore from './ServiceInformationAccordionFormStore'

class ServiceStore extends PagedCollectionStore {
  wsKey = 'ServiceStore'
  currentServiceData = null
  toGuaranteePhotosUrls = []
  toGuaranteeList = null
  serviceOrderPhotosUrls = []
  completedServiceOrderPhotosUrls = []
  photosInfoList = null
  photosClarificationList = null
  impossibleList = null
  impossiblePhotosUrls = []
  improvementRequiredList = null
  improvementRequiredPhotosUrls = []
  maintenanceCompletedList = null
  maintenanceCompletedPhotosUrls = []
  servicePhotos = {}

  constructor() {
    super({ action: getServiceOrders })
    this.wsConnection = webSocketService
    this.pageSize = 100
    this.serviceStore = true
    this.params = null
    this.photosId = null
    this.onSiteDrawerType = 'to-guarantee-repair'
    this.servicePhotos = this.getServicePhotos()

    makeObservable(this, {
      toGuaranteeList: observable,
      toGuaranteePhotosUrls: observable,
      reasonCategories: observable,
      installedOrders: observable,
      showSearchResult: observable,
      searchByIdMode: observable,
      searchByPhoneMode: observable,
      isLoading: observable,
      haveNotFound: observable,
      showContinueInfo: observable,
      showAddServiceRequestForm: observable,
      checkedSeviceOrder: observable,
      wsConnection: observable,
      isChecked: action,
      showToggleToPhoneBtn: observable,
      equipmentIdError: computed,
      newEquipment: observable,
      showInfoDrawer: observable,
      setShowInfoDrawer: action,
      showAssignToDealerView: observable,
      currentInfoDrawerData: observable,
      newDealer: observable,
      setShowAssignToDealerView: action,
      clearCheckedSeviceOrder: action,
      openedAccordionIndex: observable,
      setOpenedAccordionIndex: action,
      comment: observable,
      setComment: action,
      disabledBtnSubmitRequest: observable,
      toggleDisabledBtnSubmitRequest: action,
      newStatus: observable,
      photosId: observable,
      currentServiceData: observable,
      servicePhotos: observable,

      serviceOrderPhotosUrls: observable,
      completedServiceOrderPhotosUrls: observable,
      photosInfoList: observable,
      photosClarificationList: observable,
      clearServicePhotosUrls: action,

      fromDrawer: observable,
      setFromDrawer: action,
      getUploadServicePhotoSettingsFunc: action,
      selectedTab: observable,
      editSelectTab: action,
      toggleStatusOnly: observable,
    })
    this.categoriesStore = getComp('CategoriesStore')
    this.installationReasonStore = getComp('InstallationReasonStore')
    this.serviceFilterStore = new ServiceFilterStore()
    this.serviceAddRequestFormStore = new ServiceAddRequestFormStore()
    this.serviceInformationAccordionFormStore =
      new ServiceInformationAccordionFormStore()
    this.intermediateDrawerFormStore = new IntermediateDrawerFormStore()
    this.statusesStore = getComp('StatusesStore')
    this.dealersStore = getComp('DealersStore')
    this.loadParams = {
      ...this.loadParams,
      size: 100,
      page: this.pageNumber,
    }

    this.setWsSubscribe()
  }

  intl = gState['intl']
  comment = ''
  selectedTab = null
  disabledBtnSubmitRequest = false
  reasonCategories = [] // список причин обращения
  installedOrders = [] // список найденных установленных заказов
  showSearchResult = false
  toggleStatusOnly = false // ножно для того чтобы скрыть весь контент при редактировании статуса
  searchByIdMode = true
  searchByPhoneMode = false
  haveNotFound = false
  showContinueInfo = false
  showAddServiceRequestForm = false
  showRequestPreview = false
  showToggleToPhoneBtn = false
  checkedSeviceOrder = null // выбранная заявка в дровере
  checkedServiceTableOrderIds = [] // выбранные заявки в таблице

  newEquipment = ''

  isLoading = false

  currentInfoDrawerData = null
  showInfoDrawer = false
  showAssignToDealerView = false
  newDealer = null

  openedAccordionIndex = 0

  newStatus = null
  serviceReceivers = null

  fromDrawer = false
  uploadServicePhotoSettings = null // настройки загрузки фотографий

  setWsSubscribe = () => {
    this.wsConnection.setSubscribe(this.wsKey, (data) => {
      const { type, maintenanceOrderId } = data

      switch (type) {
        case 6:
          this.changeCollectionWsAction(maintenanceOrderId, type)
          break
        case 7:
          this.changeCollectionWsAction(maintenanceOrderId, type)
          break
        default:
          break
      }
    })
  }

  setOnSiteDrawerType = (type) => {
    this.onSiteDrawerType = type
  }

  setComment = (e) => {
    this.comment = e.target.value
  }
  setToggleStatusOnly = (close) => {
    this.toggleStatusOnly = close ? null : !this.toggleStatusOnly
  }
  toggleDisabledBtnSubmitRequest = (value) => {
    // не дает вернуть заявку во время редактирования
    this.disabledBtnSubmitRequest = value
  }

  setFromDrawer = (value) => {
    // если обнулить то вернет к первой заявке(начало экрана)
    this.fromDrawer = value
  }

  clearServicePhotosUrls = () => {
    this.toGuaranteeList = null
    this.toGuaranteePhotosUrls = []
    this.photosId = null
    this.serviceOrderPhotosUrls = []
    this.completedServiceOrderPhotosUrls = []
    this.photosClarificationList = null
    this.photosInfoList = null
    this.impossibleList = null
    this.impossiblePhotosUrls = []
    this.improvementRequiredList = null
    this.improvementRequiredPhotosUrls = []
    this.maintenanceCompletedList = null
    this.maintenanceCompletedPhotosUrls = []
  }

  setOpenedAccordionIndex = (index) => {
    this.openedAccordionIndex = index
  }

  setShowAssignToDealerView = (value) => {
    this.showAssignToDealerView = value
  }

  setShowInfoDrawer = (data) => {
    if (data !== null) {
      this.currentInfoDrawerData = data
    }
  }

  updateCurrentInfoDrawerData = () => {
    const currentId = this.currentInfoDrawerData.id
    this.currentInfoDrawerData = this.collection.find(
      (item) => item.id === currentId,
    )
  }

  setShowRequestPreview = (value) => {
    this.showRequestPreview = value
    this.showAddServiceRequestForm = !value //уточнить поведение
  }

  getTechnicalData = () => {
    if (!this.reasonCategories.length) {
      getServiceReasons().then((res) => {
        this.reasonCategories = res.maintenanceReasons
      })
    }
  }

  gerReworkPagedData = (param) => {
    const isSamePage = this.selectedTab === 3

    if (param && Object.keys(param)?.length) {
      this.params = param
      this.pageSize = param?.size ?? 100
    } else if ((!this.params && !param) || !isSamePage) {
      this.params = { page: 0, size: 100 }
      this.pageSize = param?.size ?? 100
    }

    getReworkServiceOrders(this.params).then((res) => {
      const newData =
        this.currentServiceData?.id &&
        res?.content?.find((el) => el.id === this.currentServiceData?.id)

      newData &&
        (this.currentServiceData = { ...this.currentServiceData, ...newData })
      this.setData(res)
    })
  }

  reLoadpageSize = () => {
    this.pageSize = 100
  }

  updateCurrentServiceData = (newData) => {
    if (this.currentServiceData) {
      const status =
        newData.status === 6
          ? +`${newData.status}.${newData.ticketStatus}`
          : newData.status
      this.currentServiceData = {
        ...this.currentServiceData,
        ...newData,
        status: status,
      }
      if (
        this.currentServiceData.oldEquipmentSerialNumber &&
        !newData.oldEquipmentSerialNumber
      )
        this.currentServiceData.oldEquipmentSerialNumber = null
    }
  }

  get serviceCollection() {
    this.collection.map((order) => {
      this.checkedServiceTableOrderIds.find((id) => id === order.id) &&
        (order.checked = true)

      if (order.ticketStatus && order.status === 6) {
        let complexStatus =
          Number(order.status) + '.' + Number(order.ticketStatus)
        complexStatus = Number(complexStatus)

        order.status = complexStatus
      }

      return order
    })

    return this.collection
  }

  loadPageAction(page, pageSize = null) {
    this.pageNumber = page
    if (pageSize) {
      this.pageSize = pageSize
    }

    const queryParam = {
      ...this.loadParams,
      page,
      size: this.pageSize,
    }
    if (this.selectedTab === 2 || !isOperator()) {
      this.reLoad(queryParam)
    } else {
      this.gerReworkPagedData(queryParam)
    }
  }

  normalizePhoneNumber(phoneNumber) {
    return phoneNumber.replace(/\D/g, '')
  }

  getInstalledOrders = () => {
    this.setOpenedAccordionIndex(0)
    const params = {
      equipmentId: this.serviceAddRequestFormStore.data.equipmentId || null,
      phoneNumber:
        this.normalizePhoneNumber(
          this.serviceAddRequestFormStore.data.phoneNumber,
        ) || null,
    }

    if (params.equipmentId || params.phoneNumber) {
      openModalFn['progress-backdrop']()
      this.isLoading = true
      getInstalledOrders(params).then((res) => {
        // изменяю поле льготных категорий в обьекте заявки для отображения
        const normalizedOrders = res.orders.map((order) => {
          return {
            ...order,
            preferentialCategories: this.categoriesStore.formatCategory(
              order.preferentialCategories,
            ),
            installationReasonId:
              this.installationReasonStore.getInstallationReasonName(
                order.installationReasonId,
              ),
          }
        })

        this.installedOrders = normalizedOrders
        this.showSearchResult = true
        if (!this.installedOrders.length) {
          this.haveNotFound = true
          this.showToggleToPhoneBtn = true
        }

        closeModalFn['progress-backdrop']()
        this.isLoading = false
      })
    }
  }

  clearInputs = () => {
    this.serviceAddRequestFormStore.clear()
  }

  onCloseDrawer = (withAccepting = false) => {
    const onClose = () => {
      closeModalFn['create-service-request']()
      this.showSearchResult = false
      this.clearInputs()
      this.searchByIdMode = true
      this.searchByPhoneMode = false
      this.haveNotFound = false
      this.showContinueInfo = false
      this.showAddServiceRequestForm = false
      this.showRequestPreview = false
      this.clearCheckedSeviceOrder()
      this.installedOrders = []
      this.showToggleToPhoneBtn = false
      this.setOpenedAccordionIndex(0)
    }

    if (withAccepting) {
      openModalFn['transaction-confirmation']?.({
        text1:
          'Есть несохраненные изменения. Вы действительно хотите выйти без сохранения?',
        action: onClose,
        withoutTimeout: true,
        acceptBtnText: 'Выйти',
      })
    } else {
      onClose()
    }
  }

  toggleOnPhoneSearchMode = () => {
    this.searchByIdMode = false
    this.searchByPhoneMode = true
    this.showSearchResult = false
    this.serviceAddRequestFormStore.data.equipmentId = ''
  }

  toggleToShowContinueInfo = () => {
    this.serviceAddRequestFormStore.data.equipmentId = ''
    this.searchByIdMode = false
    this.searchByPhoneMode = false
    this.showSearchResult = false
    this.showContinueInfo = true
  }

  showToggleToPhoneBtnFunc = () => {
    this.showToggleToPhoneBtn = true
  }

  goOnStartDrawer = () => {
    this.searchByIdMode = true
    this.searchByPhoneMode = false
    this.haveNotFound = false
    this.showContinueInfo = false
    this.showAddServiceRequestForm = false
    this.showRequestPreview = false
    this.showToggleToPhoneBtn = false
    this.clearCheckedSeviceOrder()
    this.clearInputs()
    this.installedOrders = []
    this.showSearchResult = false
    this.setOpenedAccordionIndex(0)
  }

  clearCheckedSeviceOrder = () => {
    this.checkedSeviceOrder = null
  }

  showAddServiceRequestFormFunc = (order, saveAllFields, isEdit) => {
    if (!saveAllFields) {
      if (order && order.type !== 'click') {
        this.checkedSeviceOrder = {
          ...order,
        }

        if (this.selectedTab !== 3) {
          this.checkedSeviceOrder.preferentialCategories =
            this.categoriesStore.formatCategory(order.preferentialCategories)
        }
      }

      if (this.checkedSeviceOrder) {
        Object.keys(this.serviceAddRequestFormStore.data).forEach((key) => {
          if (
            ['phoneNumber', 'surname', 'name', 'patronymic'].includes(key) &&
            isOperator() &&
            !isEdit
          ) {
            this.checkedSeviceOrder &&
              (this.serviceAddRequestFormStore.data.phoneNumber = '')
            return
          }
          if (key === 'senderId') {
            return (this.serviceAddRequestFormStore.data[key] = Number(
              this.checkedSeviceOrder[key],
            ))
          }

          if (
            key === 'preferentialCategories' &&
            this.checkedSeviceOrder.preferentialCategories
          ) {
            const categories =
              this.categoriesStore.getIndexesOfMatchingElements(
                this.checkedSeviceOrder[key]?.split(', '),
              )

            return (this.serviceAddRequestFormStore.data[key] = categories)
          }

          if (key === 'phoneNumber') {
            return (this.serviceAddRequestFormStore.data[key] =
              this.checkedSeviceOrder['phone'] ||
              this.checkedSeviceOrder['phoneNumber'])
          }
          if (key === 'orderId') {
            return (this.serviceAddRequestFormStore.data['orderId'] =
              this.checkedSeviceOrder['id'])
          }

          if (key === 'installedOrderId') {
            return (this.serviceAddRequestFormStore.data[key] =
              this.checkedSeviceOrder['orderId'])
          }

          if (key === 'created') {
            return (this.serviceAddRequestFormStore.data[key] = moment().format(
              'DD.MM.YYYYTHH:mm:ss',
            ))
          }

          if (key === 'maintenanceReasonId') {
            return this.serviceAddRequestFormStore.data[key]
          }

          if (key === 'addressType') {
            if (this.checkedSeviceOrder[key] === null) {
              return this.serviceAddRequestFormStore.data[key]
            }
            return (this.serviceAddRequestFormStore.data[key] =
              this.checkedSeviceOrder[key])
          }

          if (
            !['incidentTypeId', 'malfunctionTypeId', 'isUrgent'].includes(key)
          ) {
            this.serviceAddRequestFormStore.data[key] =
              this.checkedSeviceOrder[key]
          }
        })
      } else {
        const savedfields = ['incidentTypeId', 'isUrgent']
        this.serviceAddRequestFormStore.clear(savedfields)
      }
    }

    this.searchByIdMode = false
    this.searchByPhoneMode = false
    this.showSearchResult = false
    this.showContinueInfo = false
    this.showRequestPreview = false
    this.showAddServiceRequestForm = true
  }

  createServiceOrder = (
    incedentTypes = [],
    incedentTypeReasons = [],
    isSolved = false,
  ) => {
    const params = {}
    const operatorRequireKeys = [
      'malfunctionExplanation',
      'incidentTypeId',
      'malfunctionTypeId',
    ]

    Object.keys(this.serviceAddRequestFormStore.data).forEach((key) => {
      if (this.serviceAddRequestFormStore.data[key]) {
        if (key === 'equipmentId') {
          return (params[key] = null)
        }
        if (key === 'maintenanceReasonId' || key === 'senderId') {
          return (params[key] = Number(
            this.serviceAddRequestFormStore.data[key],
          ))
        }

        if (key === 'created') {
          return (params[key] = moment(
            this.serviceAddRequestFormStore.data[key],
            'DD.MM.YYYYTHH:mm',
          ).format('YYYY-MM-DDTHH:mm:ssZ'))
        }
        if (operatorRequireKeys.includes(key)) {
          if (isOperator()) {
            return (() => {
              switch (key) {
                case 'incidentTypeId':
                  const currType = incedentTypes.find(
                    (el) =>
                      el.name === this.serviceAddRequestFormStore.data[key],
                  )
                  return (params[key] = currType?.id)

                case 'malfunctionTypeId':
                  const currEl = incedentTypeReasons.find(
                    (el) =>
                      el.name === this.serviceAddRequestFormStore.data[key],
                  )
                  return (params[key] = currEl?.id)

                default:
                  return (params[key] =
                    this.serviceAddRequestFormStore.data[key])
              }
            })()
          }
        }
        if (key === 'requireReasonDiscription') return
        return (params[key] = this.serviceAddRequestFormStore.data[key])
      }
    })

    this.onCloseDrawer()

    if (isSolved) {
      createServiceSolvedOrder(params).then((res) => {
        if (this.selectedTab === 3) {
          this.gerReworkPagedData()
          notifySuccess('Заявка создана')
        } else {
          this.reLoad()
          notifySuccess('Заявка создана')
        }
      })
    } else {
      createServiceOrder(params).then((res) => {
        if (this.selectedTab === 3) {
          this.gerReworkPagedData()
          notifySuccess('Заявка создана')
        } else {
          this.reLoad()
          notifySuccess('Заявка создана')
        }
      })
    }
  }

  updateOperatorsTable = () => {
    if (this.selectedTab === 3) {
      this.gerReworkPagedData()
    } else {
      this.reLoad()
    }
  }

  addThisToCheckedServiceOrder = (id) => {
    if (this.checkedSeviceOrder && this.checkedSeviceOrder.orderId === id) {
      this.checkedSeviceOrder = null
    } else {
      this.checkedSeviceOrder = this.installedOrders.find(
        (item) => item.orderId === id,
      )
    }
  }

  get checkedServiceOrderId() {
    return this.checkedSeviceOrder ? this.checkedSeviceOrder.orderId : null
  }

  selectAllOrdersOnPage = () => {
    this.installedOrders.forEach((order) => {
      order.checked = true
    })
  }

  checkOrderFunc = (order) => {
    order.checked = !order.checked

    if (this.checkedServiceTableOrderIds.find((el) => el === order.id)) {
      this.checkedServiceTableOrderIds =
        this.checkedServiceTableOrderIds.filter((el) => el !== order.id)
    } else {
      this.checkedServiceTableOrderIds.push(order.id)
    }
  }

  checkAllOrdersFunc = () => {
    if (this.serviceCollection.every((el) => el.checked)) {
      this.serviceCollection.map((el) => (el.checked = false))
      this.checkedServiceTableOrderIds = []
      return
    }

    this.serviceCollection.map((el) => {
      el.checked = true
      if (!this.checkedServiceTableOrderIds.find((id) => id === el.id)) {
        this.checkedServiceTableOrderIds.push(el.id)
      }
    })
    return
  }

  isChecked = (id) => {
    return this.checkedServiceTableOrderIds.find((el) => el === id)
      ? true
      : false
  }

  get equipmentIdError() {
    this.newEquipment = this.serviceAddRequestFormStore.data.equipmentId

    let summ
    let number
    if (this.serviceAddRequestFormStore.data.equipmentId?.length) {
      number = +this.newEquipment.slice(0, 2)
      if (this.serviceAddRequestFormStore.data.equipmentId.length > 2) {
        summ = this.serviceAddRequestFormStore.data.equipmentId
          .slice(2, 14)
          .split('')
          .reduce((acc, el) => {
            return +acc + +el
          })
      }
    }
    return !(
      this.serviceAddRequestFormStore.data.equipmentId?.length === 14 &&
      summ === number
    )
  }

  updateServiceOrder = async (selectedTab3) => {
    const params = {}

    Object.keys(this.serviceAddRequestFormStore.data).forEach((key) => {
      if (this.serviceAddRequestFormStore.data[key]) {
        if (key === 'equipmentId') {
          return (params[key] = null)
        }
        if (key === 'maintenanceReasonId' || key === 'senderId') {
          return (params[key] = Number(
            this.serviceAddRequestFormStore.data[key],
          ))
        }
        if (key === 'phone') {
          return (params[key] = this.serviceAddRequestFormStore.data[
            key
          ].replace(/\D/g, ''))
        }

        if (key === 'created') {
          return (params[key] = moment(
            this.serviceAddRequestFormStore.data[key],
            'DD.MM.YYYYTHH:mm',
          ).format('YYYY-MM-DDTHH:mm:ssZ'))
        }
        return (params[key] = this.serviceAddRequestFormStore.data[key])
      }
    })
    await updateServiceOrderPut(params).then((res) => {
      if (selectedTab3) {
        this.gerReworkPagedData()
      } else {
        if (isAdmin()) {
          this.updateCurrentServiceData(res)
        } else {
          this.updateOrders(res)
        }
      }
    })
  }

  editSelectTab = (value) => {
    this.selectedTab = value
  }

  changeServiceOrderEquipmentId = async ({ operatorStore, params }) => {
    await changeServiceEquipmentId(params)
      .then(() => {
        if (operatorStore?.selectedTab && operatorStore?.selectedTab === 3) {
          this.gerReworkPagedData()
        } else {
          this.reLoad()
        }
      })
      .finally(() => {
        closeModalFn['progress-backdrop']()
      })
  }

  availableStatusesToChange(admin, status, selectedTab) {
    const specialLoc = selectedTab === 3 && isOperator

    if (specialLoc) {
      if (status === 24) {
        const availableStatuses = [7, 21]

        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      } else if ([11].includes(status)) {
        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          [2, 7].includes(status.id),
        )
      }
    } else {
      if ((isOperator() || isAdmin()) && [1, 20, 21].includes(status)) {
        const availableStatuses = [7]
        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      } else if (admin && status === 7) {
        const availableStatuses = [2, 10]
        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      } else if (admin && status === 11) {
        const availableStatuses = [2, 7, 10]
        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      } else if (status === 11) {
        const availableStatuses = [2, 7]
        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      } else if (status === 24) {
        const availableStatuses = [7, 21]

        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      } else {
        const availableStatuses = [1, 2, 3, 4, 5]
        return this.statusesStore.reportServiceOrderStatuses.filter((status) =>
          availableStatuses.includes(status.id),
        )
      }
    }
  }

  // контроллер открытия дровера
  // сохраняет данные выбранной заявки в модалку "Текущая сервисная заявка"
  // затем открывает дровер

  serviceDrawersController = (e) => {
    this.currentServiceData = e.data
    openModalFn['common-service-drawer']()
    this.clearServicePhotosUrls()
  }

  acceptServiceOrderFunc = async (id) => {
    await acceptServiceOrder({ orderId: id })
      .then((res) => {
        this.updateOrders(res)
      })
      .finally(() => {
        closeModalFn['progress-backdrop']()
      })
  }

  openTransferToDuplicateDrawerFunc = (data) => {
    openModalFn['transfer-to-duplicate-drawer']({ serviceOrder: data })
  }

  getServiceComments = async (id) => {
    openModalFn['progress-backdrop']()
    await getServiceOrderComments(id)
      .then((res) => {
        const narmalizedCommentsArray = res.map((item) => {
          const newDate = moment.utc(item.date).toDate()
          item.date = moment(newDate).format('DD.MM.YYYY,HH:mm')

          return item
        })
        this.currentServiceData.comments = narmalizedCommentsArray
      })
      .finally(() => {
        closeModalFn['progress-backdrop']()
      })
  }

  postServiceOrderComment = async (params) => {
    await addServiceOrderComment(params)
      .then(() => {
        notifySuccess('Комментарий добавлен')
      })

      .finally(() => {
        closeModalFn['progress-backdrop']()
      })
  }

  beginWorkWithOrderFunc = async (id) => {
    openModalFn['progress-backdrop']()
    await beginWorkWithOrder({ orderId: id })
      .then((res) => {
        this.updateOrders(res)
      })
      .finally(() => {
        closeModalFn['progress-backdrop']()
      })
  }

  prepareCompleteRequestBody = () => {
    const params = {}

    const files =
      this.serviceInformationAccordionFormStore.data['files'] &&
      this.serviceInformationAccordionFormStore.data['files'].map(
        (el) => el.file,
      )
    params.dateOfMaintenance = moment(
      this.serviceInformationAccordionFormStore.data['dateOfMaintenance'],
      'DD.MM.YYYYTHH:mm',
    ).format('YYYY-MM-DDTHH:mm:ssZ')
    params.workDescription =
      this.serviceInformationAccordionFormStore.data['workDescription']

    if (files) {
      params.files = files
    }

    return params
  }

  onSuccessCompleteRequest = (res) => {
    if (res.uploaded === false) {
      res.images.map((item) => {
        if (item.error === 'Дубликат') {
          notifyError(`Дубликат: ${item.filename}`)
        }
      })

      return false
    }
    this.getServicePhotosFunc(res.id, [
      'Clarification',
      'WarrantyServiceRequired',
      'MaintenanceImpossible',
      'ImprovementRequired',
      'MaintenanceCompleted',
      'DiagnosticCompleted',
    ])
    this.updateCurrentServiceData(res)
    this.serviceInformationAccordionFormStore.clear()
    closeModalFn['on-site-service-drawer']()
    return true
  }

  prepareToGuaranteeRequestBody = () => {
    const params = {}

    const files =
      this.serviceInformationAccordionFormStore.data['files'] &&
      this.serviceInformationAccordionFormStore.data['files'].map(
        (el) => el.file,
      )
    params.dateOfVisit = moment(
      this.serviceInformationAccordionFormStore.data['dateOfVisit'],
      'DD.MM.YYYYTHH:mm',
    ).format('YYYY-MM-DDTHH:mm:ssZ')
    params.visitDescription =
      this.serviceInformationAccordionFormStore.data['visitDescription']

    if (files) {
      params.files = files
    }

    return params
  }

  toGuaranteeRepairOperatorFn = (
    incedentTypes = [],
    incedentTypeReasons = [],
  ) => {
    const params = {}
    const operatorRequireKeys = [
      'malfunctionExplanation',
      'incidentTypeId',
      'malfunctionTypeId',
    ]

    Object.keys(this.serviceAddRequestFormStore.data).forEach((key) => {
      if (this.serviceAddRequestFormStore.data[key]) {
        if (key === 'equipmentId') {
          return (params[key] = null)
        }
        if (key === 'maintenanceReasonId' || key === 'senderId') {
          return (params[key] = Number(
            this.serviceAddRequestFormStore.data[key],
          ))
        }

        if (key === 'created') {
          return (params[key] = moment(
            this.serviceAddRequestFormStore.data[key],
            'DD.MM.YYYYTHH:mm',
          ).format('YYYY-MM-DDTHH:mm:ssZ'))
        }
        if (operatorRequireKeys.includes(key)) {
          if (isOperator()) {
            return (() => {
              switch (key) {
                case 'incidentTypeId':
                  const currType = incedentTypes.find(
                    (el) =>
                      el.name === this.serviceAddRequestFormStore.data[key],
                  )
                  return (params[key] = currType?.id)

                case 'malfunctionTypeId':
                  const currEl = incedentTypeReasons.find(
                    (el) =>
                      el.name === this.serviceAddRequestFormStore.data[key],
                  )
                  return (params[key] = currEl?.id)

                default:
                  return (params[key] =
                    this.serviceAddRequestFormStore.data[key])
              }
            })()
          }
        }
        if (key === 'requireReasonDiscription') return
        return (params[key] = this.serviceAddRequestFormStore.data[key])
      }
    })
    params.receiverSerialNumber =
      this.serviceInformationAccordionFormStore.data['receiverSerialNumber']
    // поправляю время(в utc) и id модель(числовое значение)
    params.receiverModelId =
      +this.serviceInformationAccordionFormStore.data['receiverModelId']
    toGuaranteeRepairOperator(params).then(() => {
      closeModalFn['operator-to-guarantee-drawer']?.()
      this.serviceInformationAccordionFormStore.clear()
      this.onCloseDrawer()
      if (this.selectedTab === 3) {
        this.gerReworkPagedData()
        notifySuccess('Заявка создана')
      } else {
        this.reLoad()
        notifySuccess('Заявка создана')
      }
    })
  }

  checkOnUploadDublicateError = async (res, formStoreField) => {
    if (res.uploaded === false) {
      res.images.map((item) => {
        if (item.error === 'Дубликат') {
          notifyError(`Дубликат: ${item.filename}`)
        }
      })
      formStoreField = null
      return false
    }
  }

  getServicePhotosFunc = async (id, photoFieldArr) => {
    this.photosId = id

    await getServicePhotos({
      orderId: id,
    }).then((res) => {
      this.clearServicePhotosUrls()
      photoFieldArr.forEach((field) => {
        if (field === 'Clarification') {
          this.photosClarificationList = res[field]
          this.photosClarificationList?.forEach((item, i) => {
            const imageUrl =
              window.SAT.config.apiUrl +
              `/maintenance/Photos/getimage?photoId=${item.id}`
            this.photosClarificationList[i].url = imageUrl
            this.completedServiceOrderPhotosUrls.push(imageUrl)
          })
        } else if (field === 'WarrantyServiceRequired') {
          this.toGuaranteeList = res[field]
          this.toGuaranteeList?.forEach((item, i) => {
            const imageUrl =
              window.SAT.config.apiUrl +
              `/maintenance/Photos/getimage?photoId=${item.id}`
            this.toGuaranteeList[i].url = imageUrl
            this.toGuaranteePhotosUrls.push(imageUrl)
          })
        } else if (field === 'MaintenanceImpossible') {
          this.impossibleList = res[field]
          this.impossibleList?.forEach((item, i) => {
            const imageUrl =
              window.SAT.config.apiUrl +
              `/maintenance/Photos/getimage?photoId=${item.id}`
            this.impossibleList[i].url = imageUrl
            this.impossiblePhotosUrls.push(imageUrl)
          })
        } else if (field === 'ImprovementRequired') {
          this.improvementRequiredList = res[field]
          this.improvementRequiredList?.forEach((item, i) => {
            const imageUrl =
              window.SAT.config.apiUrl +
              `/maintenance/Photos/getimage?photoId=${item.id}`
            this.improvementRequiredList[i].url = imageUrl
            this.improvementRequiredPhotosUrls.push(imageUrl)
          })
        } else if (field === 'MaintenanceCompleted') {
          this.maintenanceCompletedList = res[field]
          this.maintenanceCompletedList?.forEach((item, i) => {
            const imageUrl =
              window.SAT.config.apiUrl +
              `/maintenance/Photos/getimage?photoId=${item.id}`
            this.maintenanceCompletedList[i].url = imageUrl
            this.maintenanceCompletedPhotosUrls.push(imageUrl)
          })
        } else {
          this.photosInfoList = res[field]
          this.photosInfoList?.forEach((item, i) => {
            const imageUrl =
              window.SAT.config.apiUrl +
              `/maintenance/Photos/getimage?photoId=${item.id}`
            this.photosInfoList[i].url = imageUrl
            this.serviceOrderPhotosUrls.push(imageUrl)
          })
        }
      })

      this.servicePhotos = this.getServicePhotos()
    })
  }

  getServicePhotos = () => {
    return {
      Clarification: {
        name: 'Уточнение данных',
        list: this.photosClarificationList,
        urls: this.completedServiceOrderPhotosUrls,
        isExist: !!this.completedServiceOrderPhotosUrls.length,
      },
      MaintenanceImpossible: {
        name: 'Обслуживание не выполнено',
        list: this.impossibleList,
        urls: this.impossiblePhotosUrls,
        isExist: !!this.impossiblePhotosUrls.length,
      },
      ImprovementRequired: {
        name: 'На доработку',
        list: this.improvementRequiredList,
        urls: this.improvementRequiredPhotosUrls,
        isExist: !!this.improvementRequiredPhotosUrls.length,
      },
      DiagnosticCompleted: {
        name: 'Диагностика завершена',
        list: this.photosInfoList,
        urls: this.serviceOrderPhotosUrls,
        isExist: !!this.serviceOrderPhotosUrls.length,
      },
      MaintenanceCompleted: {
        name: 'Выполнен негарантийный ремонт',
        list: this.maintenanceCompletedList,
        urls: this.maintenanceCompletedPhotosUrls,
        isExist: !!this.maintenanceCompletedPhotosUrls.length,
      },
      WarrantyServiceRequired: {
        name: 'В обработке у офиса',
        list: this.toGuaranteeList,
        urls: this.toGuaranteePhotosUrls,
        isExist: !!this.toGuaranteePhotosUrls.length,
      },
    }
  }

  sendToDiagnosticFunc = async (models = []) => {
    const params = {}
    const files = this.serviceInformationAccordionFormStore.data['files']
      ? this.serviceInformationAccordionFormStore.data['files'].map(
          (el) => el.file,
        )
      : []

    params.orderId = this.serviceInformationAccordionFormStore.data['orderId']
    params.receiverSerialNumber =
      this.serviceInformationAccordionFormStore.data['receiverSerialNumber']
    // поправляю время(в utc) и id модель(числовое значение)
    const model = models.find(
      (m) =>
        `${m.manufacturerName} ${m.name}` ===
        this.serviceInformationAccordionFormStore.data['receiverModelId'],
    )
    params.receiverModelId = model?.id
    params.dateOfSeizure = moment(
      this.serviceInformationAccordionFormStore.data['dateOfMaintenance'],
      'DD.MM.YYYYTHH:mm',
    ).format('YYYY-MM-DDTHH:mm:ssZ')
    params.files = files
    params.diagnosticPassBasisComment =
      this.serviceInformationAccordionFormStore.data[
        'diagnosticPassBasisComment'
      ]
    await sendToDiagnostic(params).then((res) => {
      if (res.uploaded === false) {
        res.images.map((item) => {
          if (item.error === 'Дубликат') {
            notifyError(`Дубликат: ${item.filename}`)
          }
        })
        return
      }
      this.serviceInformationAccordionFormStore.clear()
      this.reLoad()
      closeModalFn['transfer-to-service-center-drawer']()
    })
  }

  solvewithoutvisitFunc = async () => {
    const params = {}

    params.orderId = this.intermediateDrawerFormStore.data['orderId']
    params.comment = this.intermediateDrawerFormStore.data['comment']
    await solvewithoutvisit(params).then((res) => {
      this.intermediateDrawerFormStore.clear()
      this.updateOrders(res)
      closeModalFn['intermediate-drawer']()
    })
  }

  guaranteeRepairFunc = async (models = [], modelChanged = false) => {
    const params = {}

    params.orderId = this.intermediateDrawerFormStore.data['orderId']
    params.externalTrackingNumber =
      +this.intermediateDrawerFormStore.data['comment']
    if (modelChanged) {
      params.replacedReceiverSerialNumber =
        this.intermediateDrawerFormStore.data['replacedReceiverSerialNumber']
      // поправляю время(в utc) и id модель(числовое значение)
      const model = models.find(
        (m) =>
          `${m.manufacturerName} ${m.name}` ===
          this.intermediateDrawerFormStore.data['replacedReceiverModelId'],
      )
      params.replacedReceiverModelId = model?.id
    }

    await wrrantyDiagnostic(params).then(() => {
      this.intermediateDrawerFormStore.clear()
      this.reLoad()
      closeModalFn['intermediate-drawer']()
    })
  }

  changeCollectionWsAction = (id, type) => {
    const order = this.serviceCollection.find((order) => order.id === id)
    if (order) {
      this.serviceCollection = this.serviceCollection.map((order) => {
        if (order.id === id) {
          if (type === 7) {
            order.isTaken = false
            order.isTakenByMe = false
            notifySuccess(
              `Заявка №${id} была возвращена оператором в общий список`,
            )
          } else if (type === 6) {
            order.isTaken = true
            order.isTakenByMe = false
            notifySuccess(`Заявка №${id} была взята оператором в обработку`)
          }
        }
        return order
      })
    }
  }

  setIsTaken = ({ isTakenByMe, id }) => {
    let promise
    if (isTakenByMe) {
      promise = maintenanceOrdersRelease({ orderId: id })
    } else {
      promise = maintenanceOrdersTake({ orderId: id })
    }
    promise.then(() => this.gerReworkPagedData())
  }

  notGuaranteeRepairFunc = async (models = [], modelChanged = false) => {
    const params = {}

    params.orderId = this.intermediateDrawerFormStore.data['orderId']
    params.externalTrackingNumber =
      this.intermediateDrawerFormStore.data['comment']

    if (modelChanged) {
      params.replacedReceiverSerialNumber =
        this.intermediateDrawerFormStore.data['replacedReceiverSerialNumber']

      const model = models.find(
        (m) =>
          `${m.manufacturerName} ${m.name}` ===
          this.intermediateDrawerFormStore.data['replacedReceiverModelId'],
      )
      params.replacedReceiverModelId = model?.id
    }

    await noWrrantyDiagnostic(params).then(() => {
      this.intermediateDrawerFormStore.clear()
      this.reLoad()
      closeModalFn['intermediate-drawer']()
    })
  }

  handleReLoad = () => {
    super.reLoad()
  }

  improvementRequiredFunc = async () => {
    const params = {}
    const files = this.intermediateDrawerFormStore.data['files']
      ? this.intermediateDrawerFormStore.data['files'].map((el) => el.file)
      : null
    params.orderId = +this.intermediateDrawerFormStore.data['orderId']
    params.comment = this.intermediateDrawerFormStore.data['comment']
    params.files = files

    await improvementRequired(params).then((res) => {
      if (res.uploaded === false) {
        res.images.map((item) => {
          if (item.error === 'Дубликат') {
            notifyError(`Дубликат: ${item.filename}`)
          }
        })
        return
      }

      this.intermediateDrawerFormStore.clear()
      const closeAndReload = isOperator() || isDealer()
      closeAndReload
        ? this.reLoad()
        : isAdmin()
          ? this.updateCurrentServiceData(res)
          : this.updateOrders(res)

      closeModalFn['intermediate-drawer']()
      closeAndReload && closeModalFn['common-service-drawer']?.()
    })
  }

  serviceImpossibleFunc = async () => {
    const params = {}
    const files = this.intermediateDrawerFormStore.data['files']
      ? this.intermediateDrawerFormStore.data['files'].map((el) => el.file)
      : null
    params.orderId = +this.intermediateDrawerFormStore.data['orderId']
    params.comment = this.intermediateDrawerFormStore.data['comment']
    params.files = files

    await serviceImpossible(params).then((res) => {
      if (res.uploaded === false) {
        res.images.map((item) => {
          if (item.error === 'Дубликат') {
            if (item.error === 'Дубликат') {
              notifyError(`Дубликат: ${item.filename}`)
            }
          }
        })

        return
      }
      this.intermediateDrawerFormStore.clear()
      const closeDrawerAndReload = isOperator() || isDealer()
      closeDrawerAndReload
        ? this.reLoad()
        : isAdmin()
          ? this.updateCurrentServiceData(res)
          : this.updateOrders(res)
      closeModalFn['intermediate-drawer']()
      closeDrawerAndReload && closeModalFn['common-service-drawer']?.()
    })
  }

  markServiceOrderAsDuplicateFunc = async ({ top }, callback) => {
    openModalFn['progress-backdrop']?.()
    const params = {}
    params.orderId = top
      ? this.currentServiceData.id
      : +this.intermediateDrawerFormStore.data['orderId']
    if (this.comment || this.intermediateDrawerFormStore.data['comment']) {
      params.comment = top
        ? this.comment
        : this.intermediateDrawerFormStore.data['comment']
    }

    await markServiceOrderAsDuplicate(params)
      .then((res) => {
        this.intermediateDrawerFormStore.clear()

        if ((isOperator() && !isSuperOperator()) || isDealer()) {
          this.reLoad()
        } else if (isSuperOperator()) {
          this.updateOrders(res)
          this.reLoad()
        } else {
          if (isAdmin()) {
            this.updateCurrentServiceData(res)
          } else {
            this.updateOrders(res)
          }
        }

        callback && callback()
        closeModalFn['intermediate-drawer']()
        closeModalFn['progress-backdrop']?.()
        isDealer() && closeModalFn['common-service-drawer']()
      })
      .catch(() => {
        closeModalFn['progress-backdrop']?.()
      })
  }

  markAsRejectedByUser = async () => {
    openModalFn['progress-backdrop']?.()
    const params = {}
    const orderId = this.currentServiceData.id

    if (this.comment || this.intermediateDrawerFormStore.data['comment']) {
      params.comment =
        this.comment || this.intermediateDrawerFormStore.data['comment']
    }

    await setToRejectedByCustomer(orderId, params)
      .then((res) => {
        this.intermediateDrawerFormStore.clear()

        if (isOperator() && this.selectedTab === 3) {
          this.gerReworkPagedData()
          this.updateCurrentServiceData(res)
          closeModalFn['common-service-drawer']?.()
        } else if ((isOperator() && !isSuperOperator()) || isDealer()) {
          this.updateCurrentServiceData(res)
          this.reLoad()
        } else if (isSuperOperator()) {
          this.updateOrders(res)
          this.reLoad()
        } else {
          if (isAdmin()) {
            this.updateCurrentServiceData(res)
          } else {
            this.updateOrders(res)
          }
        }

        callback && callback()
        closeModalFn['intermediate-drawer']()
        closeModalFn['progress-backdrop']?.()
        isDealer() && closeModalFn['common-service-drawer']()
      })
      .catch(() => {
        closeModalFn['progress-backdrop']?.()
      })
  }

  backToSCAfterRevision = async () => {
    openModalFn['progress-backdrop']?.()
    const orderId = this.currentServiceData.id

    await backToServiceCenterAfterRevision(orderId)
      .then((res) => {
        this.intermediateDrawerFormStore.clear()

        if (isOperator() && this.selectedTab === 3) {
          this.gerReworkPagedData()
          this.updateCurrentServiceData(res)
          closeModalFn['common-service-drawer']?.()
        } else if ((isOperator() && !isSuperOperator()) || isDealer()) {
          this.reLoad()
        } else if (isSuperOperator()) {
          this.updateOrders(res)
          this.reLoad()
        } else {
          if (isAdmin()) {
            this.updateCurrentServiceData(res)
          } else {
            this.updateOrders(res)
          }
        }

        callback()
        closeModalFn['intermediate-drawer']()
        closeModalFn['progress-backdrop']?.()
        isDealer() && closeModalFn['common-service-drawer']()
      })
      .catch(() => {
        closeModalFn['progress-backdrop']?.()
      })
  }

  //  получение настроек для загрузки фото
  getUploadServicePhotoSettingsFunc = () => {
    if (!this.uploadServicePhotoSettings) {
      getUploadServicePhotoSettings().then((res) => {
        this.uploadServicePhotoSettings = res
      })
    }
  }

  markAsImpossible = async (admin) => {
    await serviceImpossible({
      orderId: this.currentServiceData.id,
      comment: this.comment,
    }).then((res) => {
      this.comment = ''
      this.newStatus = null
      isAdmin() ? this.updateCurrentServiceData(res) : this.gerReworkPagedData()
      const closeDrawer = isDealer() || isOperator()

      closeDrawer && closeModalFn['common-service-drawer']?.()

      notifySuccess('Заявка обновлена')
    })
  }

  assignDealer = async (admin) => {
    await assignServiceOrderOnDealer({
      dealerId: this.newDealer || this.currentServiceData.assignedDealerId,
      orderId: this.currentServiceData.id,
    }).then((res) => {
      this.newStatus = null
      isOperator()
        ? this.gerReworkPagedData()
        : isAdmin()
          ? this.updateCurrentServiceData(res)
          : this.updateOrders(res)
      isOperator() && closeModalFn['common-service-drawer']?.()

      notifySuccess('Дилер назначен')
    })
  }

  updateOrders = (newOrders) => {
    if (Array.isArray(newOrders)) {
      this.collection = this.collection.map((item) => {
        const updatedOrder = newOrders?.find((order) => order?.id === item?.id)

        if (updatedOrder?.ticketStatus && updatedOrder?.status === 6) {
          let complexStatus =
            Number(updatedOrder.status) +
            '.' +
            Number(updatedOrder.ticketStatus)
          complexStatus = Number(complexStatus)

          updatedOrder.status = complexStatus
        }

        if (updatedOrder?.id === this.currentServiceData?.id) {
          this.currentServiceData = {
            comments: this.currentServiceData?.comments,
            ...updatedOrder,
          }
        }

        return updatedOrder ? { ...item, ...updatedOrder } : item
      })
    } else {
      this.collection = this.collection.map((item) => {
        return newOrders.id === item.id ? newOrders : item
      })

      if (newOrders?.id === this.currentServiceData?.id) {
        if (newOrders?.ticketStatus && newOrders?.status === 6) {
          let complexStatus =
            Number(newOrders.status) + '.' + Number(newOrders.ticketStatus)
          complexStatus = Number(complexStatus)

          newOrders.status = complexStatus
        }

        this.currentServiceData = {
          comments: this.currentServiceData?.comments,
          ...newOrders,
        }
      }
    }
  }
}

// const mapPhotosFields = {
//   MaintenanceCompleted: 'photosInfoList',
//   Clarification: 'photosClarificationList',
//   WarrantyServiceRequired: 'toGuaranteeList',
// }

export default ServiceStore
